
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface PricingCardProps {
  name: string;
  description: string;
  price: string;
  features: string[];
  popular?: boolean;
}

export function PricingCard({
  name,
  description,
  price,
  features,
  popular = false
}: PricingCardProps) {
  return (
    <Card className={cn(
      "relative flex flex-col",
      popular && "border-finance-turquoise shadow-lg scale-105"
    )}>
      {popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <div className="bg-finance-turquoise text-white px-3 py-1 rounded-full text-sm font-medium">
            Mais Popular
          </div>
        </div>
      )}
      
      <CardHeader>
        <div className="text-2xl font-bold">{name}</div>
        <div className="text-sm text-muted-foreground">{description}</div>
      </CardHeader>
      
      <CardContent className="flex-1">
        <div className="mb-6">
          <span className="text-4xl font-bold">R$ {price}</span>
          <span className="text-muted-foreground">/mês</span>
        </div>
        
        <ul className="space-y-3">
          {features.map((feature) => (
            <li key={feature} className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 shrink-0" />
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      
      <CardFooter>
        <Button 
          variant={popular ? "default" : "outline"} 
          className="w-full"
        >
          Começar agora
        </Button>
      </CardFooter>
    </Card>
  );
}
